import { defineFcm } from '../shared/factory';

export const FCM_PROMOTIONS_INELIGIBLE_PETITION_REFUND_LIMIT = defineFcm('promotions_ineligible_petition_refund_limit')
	.asNumber()
	.withDefault(100000)
	.toConfig();
